/* eslint-disable max-lines */
import { saveUsers } from 'actions/users';
import LoadingIndicator from 'components/LoadingIndicator';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useParams, useRouteMatch } from 'react-router-dom';
import { getCustomerDomain } from 'selectors/auth';
import getUsers from 'selectors/userPermissionsPage';
import { getUserLoading } from 'selectors/users';
import { useSelector } from 'store';
import { useHistory } from 'utils/urls';

const UsersPermissionsHeader: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const route = useRouteMatch();

  const { cohortId } = useParams<{ cohortId: string }>();

  const customerDomain = useSelector(getCustomerDomain);
  const loading = useSelector(getUserLoading);

  const users = useSelector(getUsers);

  const handleConfirmSave = (): void => {
    if (cohortId && route.path.includes('import')) {
      history.pushLookup({
        routeName: 'customer-cohort-import',
        customerDomain,
        routeParams: { cohortId },
      });
    } else {
      dispatch(
        saveUsers({
          users,
          redirect: true,
          fromPermissionsPage: true,
          cohort_uuid: cohortId,
        })
      );
    }
  };

  return (
    <header className="flex flex-row justify-between items-center px-6">
      <span className="w-full text-heading-1">New Users</span>
      <button
        type="button"
        className="h-8 w-32 button button--primary whitespace-no-wrap items-center justify-center"
        onClick={handleConfirmSave}
      >
        {loading ? <LoadingIndicator size="5" /> : 'Save & Exit'}
      </button>
    </header>
  );
};

export default UsersPermissionsHeader;
